import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const ACTIVE_ORG_KEY = 'active-org-id'

function getStoredOrgId() {
    if (typeof window === 'undefined') return null
    return window.localStorage.getItem(ACTIVE_ORG_KEY)
}

function setStoredOrgId(orgId) {
    if (typeof window === 'undefined') return
    if (orgId) {
        window.localStorage.setItem(ACTIVE_ORG_KEY, orgId)
    }
}

export default function useWorkspace() {
    const [user, setUser] = useState(null)
    const [profile, setProfile] = useState(null)
    const [orgs, setOrgs] = useState([])
    const [activeOrg, setActiveOrg] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        loadWorkspace()
    }, [])

    async function loadWorkspace() {
        const { data: { user } } = await supabase.auth.getUser()
        if (!user) {
            setLoading(false)
            return
        }
        setUser(user)

        const [profileRes, orgRes] = await Promise.all([
            supabase.from('profiles').select('*').eq('id', user.id).single(),
            supabase
                .from('organization_members')
                .select('organization_id, role, organizations(id, name, slug, logo_url, nav_sections)')
                .eq('user_id', user.id),
        ])

        const nextProfile = profileRes.data || null
        setProfile(nextProfile)
        if (nextProfile && nextProfile.active === false) {
            await supabase.auth.signOut()
            setUser(null)
            setOrgs([])
            setActiveOrg(null)
            setLoading(false)
            return
        }

        const memberships = orgRes.data || []
        const organizations = memberships
            .filter(m => m.organizations)
            .map(m => ({ ...m.organizations, role: m.role }))
        setOrgs(organizations)

        const storedId = getStoredOrgId()
        const preferred = organizations.find(org => org.id === storedId) || organizations[0] || null
        if (preferred?.id) {
            setStoredOrgId(preferred.id)
        }
        setActiveOrg(preferred)
        setLoading(false)
    }

    function updateActiveOrg(orgId) {
        const next = orgs.find(org => org.id === orgId)
        if (next) {
            setActiveOrg(next)
            setStoredOrgId(next.id)
        }
    }

    const roles = activeOrg?.role || []
    const isAdmin = roles.includes('owner') || roles.includes('admin')

    return {
        user,
        profile,
        orgs,
        activeOrg,
        setActiveOrg: updateActiveOrg,
        loading,
        isAdmin,
    }
}
